import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnknownAction } from "redux";
import { AppState } from "../../store/types";
import { updateDefaultGeo, updateGeoAccess, updateRootGeo, updateSelectedGeo, updateUserEmail } from "./actions";
import { GlobalDispatch, GlobalState } from "./types";

export const useGlobalState = (): GlobalState => {
  return useSelector(({ global }: AppState) => {
    return global;
  });
};

export const useGlobalDispatch = (): GlobalDispatch => {
  const dispatch = useDispatch();
  // typescript-fsa Action<T> lacks the index signature required by Redux 5's UnknownAction;
  // as unknown as UnknownAction is an intentional compatibility shim — migrate to RTK createAction to remove it.
  return useMemo(
    (): GlobalDispatch => ({
      updateSelectedGeo: (geoPayload) => dispatch(updateSelectedGeo(geoPayload) as unknown as UnknownAction),
      updateRootGeo: (geoPayload) => dispatch(updateRootGeo(geoPayload) as unknown as UnknownAction),
      updateDefaultGeo: (geoPayload) => dispatch(updateDefaultGeo(geoPayload) as unknown as UnknownAction),
      updateGeoAccess: (access) => dispatch(updateGeoAccess(access) as unknown as UnknownAction),
      updateUserEmail: (email) => dispatch(updateUserEmail(email) as unknown as UnknownAction),
    }),
    [dispatch],
  );
};
